"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../BaseComponent");
var HegydCore_1 = require("../utils/HegydCore");
var Toaster_1 = require("../utils/Toaster");
var Favorite = /** @class */ (function (_super) {
    __extends(Favorite, _super);
    function Favorite($view) {
        var _this = _super.call(this, $view) || this;
        _this.init();
        return _this;
    }
    Favorite.prototype.init = function () {
        this.initListeners();
    };
    Favorite.prototype.initListeners = function () {
        var _this = this;
        this.$view.on('change', Favorite.selectorSelectProduct(), function (e) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, this.chooseProduct(e)];
        }); }); });
        this.$view.on('click', 'button.add', function (e) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, this.addProduct(e)];
        }); }); });
        this.$view.on('click', 'button.remove', function (e) { return Favorite.removeListDecli(e); });
    };
    Favorite.prototype.chooseProduct = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var el, val, isFirstProduct;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        el = $(e.target);
                        val = el.val();
                        isFirstProduct = this.$view.find('.element_ouvrage').length === 0;
                        console.log(isFirstProduct);
                        return [4 /*yield*/, this.getListDecli(val, el, isFirstProduct)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Favorite.prototype.addProduct = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = $(e.target).data('route');
                        return [4 /*yield*/, this.loadNewProduct(url)];
                    case 1:
                        _a.sent();
                        this.hideBtnAdd();
                        return [2 /*return*/];
                }
            });
        });
    };
    Favorite.removeListDecli = function (e) {
        Favorite.removeDiv($(e.target));
    };
    Favorite.removeSelect = function ($select) {
        $select.parent().parent().remove();
    };
    Favorite.removeDiv = function ($btn) {
        $btn.parents('.element_ouvrage').remove();
    };
    Favorite.prototype.showBtnAdd = function () {
        this.elementButtonAddProduct().removeAttr('disabled');
    };
    Favorite.prototype.hideBtnAdd = function () {
        this.elementButtonAddProduct().attr('disabled', 'disabled');
    };
    Favorite.getOuvrageId = function () {
        return parseInt(Favorite.elementContainerGlobal().data('ouvrage_id'));
    };
    Favorite.prototype.getListDecli = function (product_id, el, isFirstProduct) {
        return __awaiter(this, void 0, void 0, function () {
            var searchParams, url, response, data, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        searchParams = new URLSearchParams();
                        url = new URL(Favorite.elementContainerGlobal().data('route'));
                        searchParams.set("product_id", product_id.toString());
                        searchParams.set("ouvrage_id", Favorite.getOuvrageId().toString());
                        searchParams.set("isFirstProduct", isFirstProduct.toString());
                        url.search = searchParams.toString();
                        return [4 /*yield*/, fetch(url.toString(), {
                                method: 'GET',
                                headers: { "X-Requested-With": "XMLHttpRequest" },
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        if (response.ok) {
                            this.showBtnAdd();
                            Favorite.removeSelect(el);
                            data.lists_decli.map(function (list_decli) {
                                Favorite.elementContainerGlobal().append(list_decli);
                            });
                        }
                        else {
                            message = void 0;
                            if (data.message) {
                                message = data.message;
                            }
                            else {
                                message = data.responseJSON;
                            }
                            (0, Toaster_1.default)(message);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Favorite.prototype.loadNewProduct = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var number, ouvrage_id, response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        number = Favorite.elementSelectProduct().length + 1;
                        ouvrage_id = Favorite.getOuvrageId();
                        return [4 /*yield*/, fetch(url + ("?number=" + number + "&ouvrage_id=" + ouvrage_id), { method: 'GET' })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        if (response.ok) {
                            Favorite.elementContainerGlobal().append(data.new_product);
                            HegydCore_1.default.initSelect2();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Favorite.selectorSelectProduct = function () {
        return 'select.select_product';
    };
    Favorite.elementSelectProduct = function () {
        return $(Favorite.selectorSelectProduct());
    };
    Favorite.seletorContainerGlobal = function () {
        return '#container';
    };
    Favorite.elementContainerGlobal = function () {
        return $(Favorite.seletorContainerGlobal());
    };
    Favorite.prototype.elementButtonAddProduct = function () {
        return this.$view.find('.add');
    };
    return Favorite;
}(BaseComponent_1.default));
exports.default = Favorite;
